// @ts-expect-error Untyped import
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import { useIframedApplication } from '../hooks/useIframedApplication';
import { IFrameContextHandler } from './IFrameContextHandler';
import { getIFrameSrc } from './urls';
import { jsx as _jsx } from "react/jsx-runtime";
export function createIFramedApplication({
  getIframeSrcPath,
  appName,
  id
}) {
  /**
   * @note <ModalHost/> must always be rendered (no conditionals) so it is ready to receive init events */
  const ModalHost = ({
    isOpen,
    onClose,
    initializeArgs
  }) => {
    const {
      contextHandler,
      handleError,
      handleOnReady,
      handleMessage,
      handleClose
    } = useIframedApplication({
      isOpen,
      onClose,
      initializeArgs
    });
    return /*#__PURE__*/_jsx(UIModalIFrame, {
      appName: appName,
      iframePassthruProps: {
        // props that are passed directly to the iframe
        id,
        name: id
      }
      // the iframe will not load at all if the sync times out, so using a massive timeout to be safe.
      ,
      initTimeout: 60000,
      preload: true,
      show: isOpen,
      use: "fullscreen",
      width: "100%",
      height: "100%",
      src: getIFrameSrc(appName, getIframeSrcPath()),
      showLoadingIndicator: !contextHandler,
      onInitError: handleError,
      onReady: handleOnReady,
      onReadyError: handleError,
      onMessage: handleMessage,
      onClose: handleClose
    });
  };
  return {
    ModalHost,
    iframeHandlers: {
      getHostIFrameHandler: embeddedContext => new IFrameContextHandler(embeddedContext),
      getEmbeddedIFrameHandler: embeddedContext => new IFrameContextHandler(embeddedContext)
    }
  };
}